import { HttpClient } from '@/http-client';
import VueApiPlugin from '@homeserve/vue-api-plugin';
import Vue from 'vue';

Vue.use(VueApiPlugin, { http: HttpClient });
